import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  id: "kt_aside",
  class: "aside aside-hoverable aside-light",
  "data-kt-drawer": "true",
  "data-kt-drawer-name": "aside",
  "data-kt-drawer-activate": "{default: true, lg: false}",
  "data-kt-drawer-overlay": "true",
  "data-kt-drawer-width": "{default:'200px', '300px': '250px'}",
  "data-kt-drawer-direction": "start",
  "data-kt-drawer-toggle": "#kt_aside_mobile_toggle"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", {
  class: "aside-logo flex-column-auto",
  id: "kt_aside_logo"
}, [
  /*#__PURE__*/_createElementVNode("a", { href: "#" }, [
    /*#__PURE__*/_createElementVNode("img", {
      alt: "Logo",
      src: "/media/logos/SoundCodeLogo.png",
      class: "h-45px logo mt-5"
    })
  ])
], -1)
const _hoisted_3 = { class: "aside-menu flex-column-fluid" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_KTMenu = _resolveComponent("KTMenu")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createVNode(_component_KTMenu)
    ])
  ]))
}